import { TableCell } from "@mui/material";
import { type ClassValue } from "clsx";
import { ReactNode } from "react";
import { cn } from "./lib/utils";
import { ArrowDropDown, ArrowDropUp, Close } from "@mui/icons-material";

export function SortableTH({
  sortDir,
  onSortAsc,
  onSortDesc,
  onSortClear,
  className,
  children,
  amISorted,
}: {
  children: ReactNode;
  className?: ClassValue[][];
  sortDir?: "asc" | "desc";
  onSortAsc: () => void;
  onSortDesc: () => void;
  onSortClear: () => void;
  amISorted: boolean;
}) {
  return (
    <TableCell
      className={cn(className, ["group hover:bg-gray-50 cursor-pointer"])}
      onClick={() =>
        amISorted && sortDir === "asc" ? onSortDesc() : amISorted && sortDir === "desc" ? onSortClear() : onSortAsc()
      }>
      <div className="flex items-center">
        {children}
        <div
          className={cn(
            [
              "invisible group-hover:visible group-hover:bg-white absolute right-2 top-3 size-3 flex items-center justify-center rounded-full ",
            ],
            amISorted ? ["visible bg-white"] : []
          )}>
          {sortDir === undefined || !amISorted ? (
            <ArrowDropUp />
          ) : sortDir === "asc" ? (
            <>
              <ArrowDropUp className="group-hover:hidden" />
              <ArrowDropDown className="hidden group-hover:block" />
            </>
          ) : (
            <>
              <ArrowDropDown className="group-hover:hidden" />
              <Close className="hidden group-hover:block size-3" />
            </>
          )}
        </div>
      </div>
    </TableCell>
  );
}
